module.exports = __webpack_public_path__ + "img/fswan.e88899bd.jpg";